import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/**
 * One merge: a 2×2 L1 cluster at the top of the board pays 0.20 and badges its four cells x2; each top candy drops into
 * the one below it, which turns into an L2, and new candies drop into the top row. The two L2 sit side by side, one
 * pair short of a cluster: the spin ends.
 */
export function mergeSingle(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-single", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L3", "L2", "L1", "L1", "H2", "L4"],
        ["L4", "H1", "L1", "L1", "L3", "L2"],
        ["L2", "L3", "L4", "H3", "L1", "L3"],
        ["H2", "L1", "L3", "L2", "L4", "L1"],
        ["L1", "L4", "H1", "L4", "L2", "H3"],
        ["L3", "L2", "L4", "L1", "H4", "L2"],
      ],
      refill: [[], [], ["H4"], ["L3"], [], []],
    })
    .build();
}
